import type { DemoKey } from '../types';

export const ko: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': '수학 · 통계',
  'app.title': '통계',
  'panel.experiment': '장면',
  'panel.params': '매개변수',

  'exp.survey-explorer.title': '설문 탐색기',
  'exp.survey-explorer.desc': '열을 고르면 데모가 알맞은 요약을 선택합니다.',
  'exp.distribution-sculptor.title': '분포 조각가',
  'exp.distribution-sculptor.desc': '점을 끌어 통계량의 반응을 보세요.',
  'exp.two-variable-lab.title': '이변수 실험실',
  'exp.two-variable-lab.desc': '산점, 적합, 그리고 인과의 질문.',
  'exp.sampling-lab.title': '표집 실험실',
  'exp.sampling-lab.desc': '기법과 크기가 표본평균을 어떻게 움직이나.',
  'exp.probability-diagrams.title': '확률 도해',
  'exp.probability-diagrams.desc': '복합사건의 벤·트리 보기.',

  'type.qualitative-nominal.label': '질적 · 명목',
  'type.qualitative-nominal.def': '본래 순서가 없는 범주.',
  'type.qualitative-ordinal.label': '질적 · 서열',
  'type.qualitative-ordinal.def': '의미 있는 순서를 가진 범주.',
  'type.qualitative-multi.label': '질적 · 다중값',
  'type.qualitative-multi.def': '관찰마다 여러 태그가 가능.',
  'type.quantitative-discrete.label': '양적 · 이산',
  'type.quantitative-discrete.def': '고정 간격으로 나오는 수.',
  'type.quantitative-continuous.label': '양적 · 연속',
  'type.quantitative-continuous.def': '연속 척도로 잰 수.',

  'column.name.label': '학생 이름',
  'column.height_cm.label': '키',
  'column.shoe_size_eu.label': '신발 사이즈 (EU)',
  'column.study_hours.label': '주당 학습 시간',
  'column.test_score.label': '시험 점수',
  'column.sports_played.label': '하는 운동',
  'column.eye_color.label': '눈 색',
  'column.commute_min.label': '통학 시간',
  'column.grade_year.label': '학년',
  'column.homework_effort.label': '숙제 노력',
  'column.ice-cream-sales.label': '아이스크림 판매',
  'column.drownings.label': '익사',
  'column.month.label': '월',
  'column.storks.label': '황새',
  'column.births.label': '출생',
  'column.country_area_km2.label': '국토 면적',
  'column.sleep_hours.label': '수면 시간',
  'column.reaction_ms.label': '반응 시간',

  'dataset.master-survey.label': '학급 설문',
  'dataset.master-survey.desc': '시뮬레이션 학생 30명.',
  'dataset.spurious-ice-cream-vs-drownings.label': '아이스크림 판매 vs 익사',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    '둘 다 계절을 따라 오르내림. 익사가 판매를 일으키지 않습니다.',
  'dataset.spurious-storks-vs-births.label': '황새 vs 출생',
  'dataset.spurious-storks-vs-births.desc':
    '큰 나라일수록 황새도 많고 출생도 많습니다. 새가 원인이 아닙니다.',
  'dataset.real-sleep-vs-reaction-time.label': '수면 vs 반응 시간',
  'dataset.real-sleep-vs-reaction-time.desc':
    '잠을 더 자면 반응이 빨라집니다. 실제 음의 상관 — 그럴듯한 메커니즘 포함.',

  'tag.football.label': '축구',
  'tag.basketball.label': '농구',
  'tag.volleyball.label': '배구',
  'tag.swimming.label': '수영',
  'tag.none.label': '없음',

  'population.gaussian.label': '종 모양',
  'population.right-skewed.label': '오른쪽 치우침',
  'population.bimodal.label': '이봉 (층화)',
  'population.uniform.label': '균등',

  'venn.dice-even-or-prime.label': '주사위: 짝수 또는 소수',
  'venn.class-sports-2set.label': '운동 (2 집합)',
  'venn.class-sports-3set.label': '운동 (3 집합)',
  'venn.custom.label': '사용자 지정',

  'tree.draw-without-replacement.label': '비복원 추출',
  'tree.custom.label': '사용자 지정',
  'tree.coin.heads': '앞',
  'tree.coin.tails': '뒤',
  'tree.draw.start': '주머니: 빨강 2, 파랑 3',
  'tree.draw.red': '빨강',
  'tree.draw.blue': '파랑',
  'tree.custom.start': '시작',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': '히스토그램',
  'card.cumulative': '누적 도수',
  'card.box': '상자 그림',
  'card.summary': '5수 요약',
  'card.bar': '막대 그래프',
  'card.mode': '최빈값',
  'card.tag-frequency': '태그 빈도',
  'card.mode-tag': '최빈 태그',
  'card.empty-no-order': '해당 없음',
  'card.empty-multi': '해당 없음',
  'card.numberline': '수직선',
  'card.scatter': '산점',
  'card.description': '무슨 일',
  'card.population': '모집단',
  'card.sampling-distribution': '표본평균',
  'card.venn': '벤',
  'card.tree': '나무',
  'card.probabilities': '확률',

  'param.dataset.label': '데이터셋',
  'param.column.label': '열',
  'param.bins.label': '구간',
  'param.shape.label': '초기 모양',
  'param.show-mean.label': '평균 표시',
  'param.show-median.label': '중앙값 표시',
  'param.x-col.label': 'X 열',
  'param.y-col.label': 'Y 열',
  'param.show-regression.label': '회귀선',
  'param.show-residuals.label': '잔차',
  'param.show-confounder.label': '교란요인 표시',
  'param.population.label': '모집단',
  'param.technique.label': '기법',
  'param.sample-size.label': '표본 크기',
  'param.stratum.label': '층',
  'param.bias.label': '편향',
  'param.mode.label': '모드',
  'param.preset.label': '프리셋',
  'param.universe.label': '우주 크기',
  'param.show-prob.label': '확률 표시',
  'param.treat-as-numeric.label': '수치로 취급',

  'stat.count': '개수',
  'stat.mean': '평균',
  'stat.median': '중앙값',
  'stat.range': '범위',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': '이상값',
  'stat.r': '피어슨 r',
  'stat.r2': 'r²',
  'stat.slope': '기울기',
  'stat.intercept': '절편',
  'stat.n': 'n',
  'stat.population-mean': '실제 평균',
  'stat.latest-sample-mean': '표본 평균',
  'stat.sample-mean-spread': '표본 평균 SD',
  'stat.sample-count': '추출 표본 수',
  'outlier.upper': '상측 이상값',
  'outlier.lower': '하측 이상값',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': '재표집',
  'btn.run-100': '100회 표집',
  'btn.stop': '정지',
  'btn.clear-history': '기록 지우기',

  'explainer.no-order': '순서 없음 → 누적 없음, 상자 없음.',
  'explainer.multi-no-iqr': '다중값 → 사분위 / IQR 미정의.',
  'message.no-data': '데이터 없음.',
  'message.needs-quartiles': '사분위에 ≥4개 점 필요.',
  'message.x-zero-variance': 'X 분산이 0 — 적합 불가.',
  'message.n-too-small': 'n이 너무 작음.',
  'message.stratum-clamp': '층의 행이 요청보다 적음 — 전부 사용.',
  'message.siblings-sum-to-one': '형제 합은 1이어야 함.',
};
